module.exports = {
      id: "spiritual-usage",
      viewBox: "0 0 27.233 28.49",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#spiritual",
      toString: function () {
        return this.url;
      }
    }